import { Link } from 'react-router-dom';
import { Navbar } from '@/components/Navbar';
import { Button } from '@/components/ui/button';
import { FileText, Ship, Globe, DollarSign, Package } from 'lucide-react';

export default function Dashboard({ user }) {
  return (
    <div className="min-h-screen bg-[#0A0E1A]">
      <Navbar user={user} />
      
      <div className="max-w-7xl mx-auto px-6 py-12" data-testid="dashboard-page">
        <h1 className="text-4xl md:text-5xl font-bold tracking-tighter uppercase mb-8">
          <span className="text-white">WELCOME, </span>
          <span className="text-[#00A6E8]">{user?.company_name || user?.individual_name || 'CLIENT'}</span>
        </h1>
        
        <p className="text-slate-400 mb-12">Manage your logistics operations from your command center.</p>
        
        {/* Quick Actions */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
          <Link to="/import" data-testid="quick-action-import">
            <div className="bg-[#0F172A] border border-white/10 rounded-lg p-6 hover:border-[#00A6E8]/50 hover:glow-cyan transition-all duration-300 h-full">
              <Ship className="text-[#00A6E8] mb-4" size={32} />
              <h3 className="text-xl font-bold text-white mb-2 uppercase">Submit Import</h3>
              <p className="text-slate-400 text-sm">Create new import drayage order</p>
            </div>
          </Link>
          
          <Link to="/export" data-testid="quick-action-export">
            <div className="bg-[#0F172A] border border-white/10 rounded-lg p-6 hover:border-[#FFA726]/50 hover:glow-gold transition-all duration-300 h-full">
              <Globe className="text-[#FFA726] mb-4" size={32} />
              <h3 className="text-xl font-bold text-white mb-2 uppercase">Submit Export</h3>
              <p className="text-slate-400 text-sm">Create new export booking</p>
            </div>
          </Link>
          
          <Link to="/rate-request" data-testid="quick-action-rate">
            <div className="bg-[#0F172A] border border-white/10 rounded-lg p-6 hover:border-white/30 transition-all duration-300 h-full">
              <DollarSign className="text-white mb-4" size={32} />
              <h3 className="text-xl font-bold text-white mb-2 uppercase">Request Rate</h3>
              <p className="text-slate-400 text-sm">Get pricing for your shipment</p>
            </div>
          </Link>
          
          <Link to="/my-shipments" data-testid="quick-action-shipments">
            <div className="bg-[#0F172A] border border-white/10 rounded-lg p-6 hover:border-white/30 transition-all duration-300 h-full">
              <Package className="text-white mb-4" size={32} />
              <h3 className="text-xl font-bold text-white mb-2 uppercase">My Shipments</h3>
              <p className="text-slate-400 text-sm">View all your loads</p>
            </div>
          </Link>
        </div>
        
        {/* Account Status */}
        <div className="bg-[#0F172A] border border-white/10 rounded-lg p-8" data-testid="account-status">
          <h2 className="text-2xl font-bold text-white mb-6 uppercase">Account Status</h2>
          
          <div className="grid md:grid-cols-3 gap-6">
            <div>
              <p className="text-slate-400 text-sm mb-2">Client Type</p>
              <p className="text-white font-semibold">{user?.client_type}</p>
            </div>
            
            <div>
              <p className="text-slate-400 text-sm mb-2">Payment Terms</p>
              <p className="text-white font-semibold">{user?.preferred_payment_terms}</p>
            </div>
            
            <div>
              <p className="text-slate-400 text-sm mb-2">Rate Agreement</p>
              <p className="text-white font-semibold">{user?.has_rate_agreement ? 'Active' : 'Not Active'}</p>
            </div>
            
            <div>
              <p className="text-slate-400 text-sm mb-2">Verification Status</p>
              <span className={`px-3 py-1 rounded-sm text-xs font-bold uppercase ${
                user?.verified 
                  ? 'bg-green-400/10 text-green-400 border border-green-400/20' 
                  : 'bg-yellow-400/10 text-yellow-400 border border-yellow-400/20'
              }`}>
                {user?.verified ? 'Verified' : 'Pending'}
              </span>
            </div>
            
            <div>
              <p className="text-slate-400 text-sm mb-2">Email</p>
              <p className="text-white font-semibold">{user?.email}</p>
            </div>
            
            <div>
              <p className="text-slate-400 text-sm mb-2">Phone</p>
              <p className="text-white font-semibold">{user?.phone}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}